import { TimePicker, type TimePickerProps } from 'antd';
import dayjs from 'dayjs';
interface Props {
  onChange: (value: dayjs.Dayjs | string | null) => void;
  value?: string | undefined;
  returnFormat?: string;
  returnTimeString?: boolean;
}
type RestProps = Omit<TimePickerProps, 'onChange' | 'value'>;

export const SchedulingTimePicker = ({
  onChange,
  value,
  returnFormat = 'HH:mm',
  returnTimeString,
  ...rest
}: Props & RestProps) => {
  const timeStringFormat = (val: dayjs.Dayjs | null) =>
    onChange(dayjs(val).format(returnFormat));
  return (
    <TimePicker
      {...rest}
      format="HH:mm"
      style={{ width: '100%' }}
      allowClear={false}
      value={value ? dayjs(value, returnFormat) : null}
      needConfirm={false}
      onChange={returnTimeString ? timeStringFormat : onChange}
      minuteStep={15}
      showNow={false}
      use12Hours={false}
    />
  );
};
